import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from '../services/jrni/api.service';
import { DatastoreService } from '../services';
import { AvailabilityService } from '../services/jrni/availability.service';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-cost-breakdown',
  templateUrl: './cost-breakdown.component.html',
  styleUrls: ['./cost-breakdown.component.scss'],
})
export class CostBreakdownComponent implements OnInit {
  @Input() costBreakDown: any;
  @Input() company: any;
  @Input() service: any;
  ceremonyDateId: number;
  date: string;
  ceremonyDate: any;
  // fees: any = [];
  totalCost: any;
  daysAway: number = 0;
  costTotal: number = 0;
  depositTotal: number = 0;
  constructor(
    private apiService: ApiService,
    public dataStore: DatastoreService,
    private availabilityService: AvailabilityService,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    console.log('init cost breakdown component', this.dataStore.serviceFees);
    if (!this.dataStore.serviceFees) {
      this.dataStore.serviceFees = [];
    }

    this.dataStore.addFees$.subscribe((feeToAdd) => {
      if (feeToAdd) {
        console.log('feeToAdd', feeToAdd);
        this.dataStore.serviceFees = this.dataStore.serviceFees.filter(
          (item) => item.questionid !== feeToAdd.questionid
        );

        // if feeToAdd.cost is nan or undefined, set it to 0
        if (isNaN(feeToAdd.cost) || feeToAdd.cost === undefined) {
          feeToAdd.cost = 0;
        }

        this.dataStore.serviceFees.push({
          questionid: feeToAdd.questionid,
          item: feeToAdd.item,
          quantity: feeToAdd.quantity || 0,
          cost: feeToAdd.cost || 0,
          deposit: feeToAdd.cost || 0,
        });
        console.log(this.dataStore.serviceFees);
        this.calculateTotal();
      }
    });

    if (!this.company) {
      this.company = this.dataStore.selectedDepartment;
    }

    if (!this.service) {
      this.service = this.dataStore.selectedService;
    }

    // if (!this.ceremonyDateId) {
    //   if (this.dataStore.config.hasOwnProperty('journey_config')) {
    //     if (this.dataStore.config.journey_config.hasOwnProperty('ceremonies')) {
    //       if (this.dataStore.config.journey_config.ceremonies.hasOwnProperty('ceremony_date_question')) {
    //         this.ceremonyDateId = parseInt(this.dataStore.config.journey_config.ceremonies.ceremony_date_question);
    //       }
    //     }
    //   }
    // }
    this.calculate();
  }

  async calculate() {
    // console.log('ceremonyDateId', this.ceremonyDateId);
    // if (this.ceremonyDateId) {
    //   const dateVal = this.dataStore.companyQuestionsForm.get(`${this.ceremonyDateId}`).value;
    //   this.ceremonyDate = moment(dateVal).format('YYYY-MM-DD');
    // }
    // console.log(this.ceremonyDate);
    const slot = await this.availabilityService.getSelectedSlot();
    console.log(slot);
    if (slot) {
      this.date = moment(slot.start).format('YYYY-MM-DD HH:mm:ss');
      this.daysAway = moment(slot.start).diff(moment(), 'd');
    }

    // if (this.ceremonyDate) {
    //   this.daysAway = moment(this.ceremonyDate).diff(moment(), 'd')
    // }
    if (!this.dataStore.isCitizenshipRoute) {
      if (this.date) {
        // Appointment prices come from extra items, not /fees — here /fees only
        // contributes the deposit and short-notice/out-of-hours surcharges. A 404
        // (no fee row for this company/service/date; reason logged by the api
        // service) therefore degrades gracefully: carry on without fee-derived
        // values instead of blocking the booking or inventing a £0.
        let fee: any = null;
        try {
          fee = await this.apiService.fees(
          this.company.id,
          this.date,
          this.service.id,
          this.service.calculated_duration
        );
        } catch (error) {
          console.warn('cost-breakdown: /fees unavailable — continuing without fee-derived surcharges', error);
        }
        this.dataStore.serviceFees = this.dataStore.serviceFees.filter(
          (item) => item.questionid !== fee?.['questionid']
        );

        const fees_extra_item_id = this.service.extra.fees_extra_item_id;
        const extraItem: any = await this.apiService.getExtraItem(
          this.company.id,
          this.service.id,
          fees_extra_item_id
        );

        if (isNaN(extraItem.item_price) || extraItem.item_price === undefined) {
          extraItem.item_price = 0;
        }

        // add service to fee
        this.dataStore.serviceFees.push({
          questionid: fee?.['questionid'],
          item: this.service.name,
          quantity: 1,
          cost: extraItem.item_price,
          deposit: fee?.['deposit'],
        });

        if (fee?.short_notice > 0) {
          if (
            this.service.extra?.hasOwnProperty('fees_extra_item_short_notice_id')
          ) {
            const extraItemShortNoticeId =
              this.service.extra.fees_extra_item_short_notice_id;
            const extraItem: any = await this.apiService.getExtraItem(
              this.company.id,
              this.service.id,
              extraItemShortNoticeId
            );
            if (
              isNaN(extraItem.item_price) ||
              extraItem.item_price === undefined
            ) {
              extraItem.price = 0;
            }
            console.log(extraItem);
            this.dataStore.serviceFees.push({
              questionid: 'noid1',
              item: extraItem.item_name,
              quantity: 1,
              cost: extraItem.item_price,
              deposit: extraItem.item_price,
              item_id: extraItemShortNoticeId,
            });
          }
        }

        if (fee?.out_of_hours > 0) {
          // get the day
          let extraItemOutOfHoursId: any = false;
          const dayOfWeek = moment(this.date).format('ddd');
          if (fee?.is_bank_holiday || dayOfWeek === 'Sun') {
            if (
              this.service.extra?.hasOwnProperty(
                'fees_extra_item_out_of_hours_sun_bank_hol_id'
              )
            ) {
              extraItemOutOfHoursId =
                this.service.extra.fees_extra_item_out_of_hours_sun_bank_hol_id;
            }
          } else {
            if (
              this.service.extra?.hasOwnProperty(
                'fees_extra_item_out_of_hours_mon_sat_id'
              )
            ) {
              extraItemOutOfHoursId =
                this.service.extra.fees_extra_item_out_of_hours_mon_sat_id;
            }
          }
          if (extraItemOutOfHoursId) {
            const extraItem: any = await this.apiService.getExtraItem(
              this.company.id,
              this.service.id,
              extraItemOutOfHoursId
            );
            if (
              isNaN(extraItem.item_price) ||
              extraItem.item_price === undefined
            ) {
              extraItem.price = 0;
            }
            console.log(extraItem);
            this.dataStore.serviceFees.push({
              questionid: 'noid2',
              item: extraItem.item_name,
              quantity: 1,
              cost: extraItem.item_price,
              deposit: extraItem.item_price,
              item_id: extraItemOutOfHoursId,
            });
          }
        }

        console.log(this.dataStore.serviceFees);
      }
    }

    this.spinner.hide();
    // if (this.daysAway > 182) {
    //   this.totalCost = this.fees.reduce((sum, fee) => sum + fee.deposit, 0);
    // }
    // else {
    //   this.totalCost = this.fees.reduce((sum, fee) => sum + fee.full_fee, 0);
    // }
    this.calculateTotal();
  }

  calculateTotal() {
    let costTotal = 0;
    let depositTotal = 0;
    costTotal = this.dataStore.serviceFees.reduce(
      (sum, fee) => sum + fee.cost * fee.quantity,
      0
    );
    if (this.daysAway > 182) {
      this.totalCost = this.dataStore.serviceFees.reduce(
        (sum, fee) => sum + fee.deposit * fee.quantity,
        0
      );
      depositTotal = this.dataStore.serviceFees.reduce(
        (sum, fee) => sum + fee.deposit * fee.quantity,
        0
      );
    } else {
      this.totalCost = this.dataStore.serviceFees.reduce(
        (sum, fee) => sum + fee.cost * fee.quantity,
        0
      );
    }
    this.dataStore.serviceFees = this.dataStore.serviceFees.sort(
      (a, b) => b.cost - a.cost
    );
    if (isNaN(this.totalCost)) {
      this.totalCost = 0; 
    }
    this.dataStore.totalCost = this.totalCost;
    this.costTotal = costTotal;
    this.depositTotal = depositTotal;
    console.log('costTotal', costTotal, 'depositTotal', depositTotal);
  }
}
